<span class="highlighted-text font-size-12 px-3 py-1 my-1 mx-auto" [ngClass]="theme">
	<ng-content></ng-content>
</span>
